import styled from 'styled-components'

export const StyledContainer = styled.div`
    display: flex;
    gap: 5px;
`
